import { gql } from '@apollo/client';
import { client as apolloClient } from '@xbcb/apollo-client';

const SEARCH_SHIPMENTS_QUERY = gql`
  query SearchShipments($input: SearchShipmentInput!) {
    searchShipments(input: $input) {
      results {
        shipper {
          tags {
            key
            value
          }
        }
      }
    }
  }
`;

const getXbtShipperId = (
  tags: Array<{ key: string; value: string }>,
): string | undefined => {
  const xbtShipperId = tags.find((tag) => tag.key === 'xbtShipperId')?.value;
  if (xbtShipperId) {
    return xbtShipperId.substring(0, xbtShipperId.indexOf(':')) || xbtShipperId;
  }
  return undefined;
};

export const getShipperIdByBookingId = async (
  bookingId: string,
): Promise<string | undefined> => {
  try {
    const { data } = await apolloClient.query({
      query: SEARCH_SHIPMENTS_QUERY,
      variables: {
        input: {
          searchCriteria: {
            bookingId: {
              values: [bookingId],
              operator: 'EQUALS',
            },
          },
        },
      },
    });

    const tags = data?.searchShipments?.results?.[0]?.shipper?.tags;
    return tags ? getXbtShipperId(tags) : undefined;
  } catch (error) {
    console.error(`Failed to get shipper for bookingId ${bookingId}:`, error);
    return undefined;
  }
};
